import { render, staticRenderFns } from "./AuthRevolution.vue?vue&type=template&id=0dcc11e3"
import script from "./AuthRevolution.vue?vue&type=script&lang=js"
export * from "./AuthRevolution.vue?vue&type=script&lang=js"
import style0 from "./AuthRevolution.vue?vue&type=style&index=0&id=0dcc11e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports